(function () {
  var BANNER_ID = 'shopify-pc__banner';
  var OVERLAY_ID = 'liva-cookie-overlay';

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    return el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  function addOverlay() {
    if (document.getElementById(OVERLAY_ID)) return; // already there
    var ov = document.createElement('div');
    ov.id = OVERLAY_ID;
    ov.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,0.6);' +
      'z-index:1999999;pointer-events:none;';
    document.body.appendChild(ov);
  }

  function removeOverlay() {
    var ov = document.getElementById(OVERLAY_ID);
    if (ov) ov.remove();
  }

  function sync() {
    var banner = document.getElementById(BANNER_ID);
    if (isVisible(banner)) {
      addOverlay();
    } else {
      removeOverlay();
    }
  }

  // Re-check whenever the DOM or the banner's attributes change
  var observer = new MutationObserver(sync);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // Also remove immediately on any click inside the banner (accept/reject/prefs)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#' + BANNER_ID)) {
      // let Shopify update first, then re-check
      setTimeout(sync, 50);
    }
  });

  // Initial check (and once DOM is ready)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();